import { getInitials } from '@/utilities/contents'

type AvatarProps = {
    name?: string | null
    className?: string
}

export const Avatar: React.FC<AvatarProps> = ({
    name = null,
    className,
}: AvatarProps) => {
    const displayName = getInitials(name || 'Unknown')

    return (
        <div
            className={`flex justify-center items-center text-sm rounded-full bg-orange-100 text-orange-800 ${
                className ?? 'w-full h-full'
            }`}
        >
            <p>{displayName}</p>
        </div>
    )
}
